exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip-link{display:inline-block;margin-bottom:0;color:#333;text-decoration:underline}.tooltip-icon{font-size:1rem;line-height:1.25rem;font-weight:400}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Tooltip/Tooltip.scss
 ** module id = 1222
 ** module chunks = 0
 **/